/**
 * THE PROMPT FIELD'S MARKDOWN EDITING — the room's behaviour for any plain textarea (owner 2026-10-22: every prompt
 * box the same): ``format(action)`` (the DeckLeftGroup buttons), and ``handleFormatKey(e)`` → true when it handled
 * the key (⌘B / ⌘I / ⌘⇧7 / ⌘⇧8, Shift+Enter continuing a list). The selection survives (applied next frame).
 */
import { applyFormat, formatShortcut, continueList } from '../utils/textFormat.js';

export function useMarkdownField(value, setValue, ref) {
  const setSel = (next) => {
    setValue(next.value);
    requestAnimationFrame(() => {
      const el = ref.current;
      if (el) { el.focus(); el.setSelectionRange(next.start, next.end); }
    });
  };
  const format = (action) => {
    const el = ref.current;
    const s = el ? el.selectionStart : String(value || '').length;
    const e = el ? el.selectionEnd : String(value || '').length;
    setSel(applyFormat(action, String(value || ''), s, e));
  };
  const handleFormatKey = (e) => {
    const fmt = formatShortcut(e);
    if (fmt) { e.preventDefault(); format(fmt); return true; }
    if (e.key === 'Enter' && e.shiftKey && e.currentTarget.selectionStart === e.currentTarget.selectionEnd) {
      const next = continueList(String(value || ''), e.currentTarget.selectionStart);
      if (next) { e.preventDefault(); setSel(next); return true; }
    }
    return false;
  };
  return { format, handleFormatKey, setSel };
}

export default useMarkdownField;
